import { render, staticRenderFns } from "./AutocompleteMunitipality.vue?vue&type=template&id=6438c718&lang=pug&"
import script from "./AutocompleteMunitipality.vue?vue&type=script&lang=js&"
export * from "./AutocompleteMunitipality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports